import { createFileRoute } from '@tanstack/react-router';
import { Forbidden } from '@/components/not-found';

export const Route = createFileRoute('/_app/403')({
  component: Forbidden,
});
